import { Column } from '@components/LinearLayout';
import styled, { css } from 'styled-components';

export const SectionContainer = styled.div<{
  backgroundImage: string;
  backgroundImageZoom?: string;
  darkOverlay?: boolean;
  height?: string;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  padding: 5rem 1rem;
  box-sizing: border-box;

  height: ${({ height }) => height || '65rem'};
  min-height: 65rem;

  width: 100%;

  background-image: url(${props => props?.backgroundImage});
  background-size: ${({ backgroundImageZoom }) =>
    backgroundImageZoom || 'cover'};
  background-position: ${({ backgroundImageZoom }) =>
    backgroundImageZoom ? 'top' : 'center'};
  background-repeat: no-repeat;

  ${({ darkOverlay }) =>
    darkOverlay &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.7);
        z-index: 1;
        pointer-events: none;
      }

      > * {
        position: relative;
        z-index: 2;
      }
    `}

  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width768}) {
    background-size: cover;
  }
`;

export const Description = styled.div<{
  color?: string;
  descriptionMaxWidth?: string;
}>`
  color: ${({ color, theme }) => color || theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: 800;
  line-height: ${({ theme }) => theme.lineHeight.height140};
  text-align: center;
  max-width: ${({ descriptionMaxWidth }) => descriptionMaxWidth || '72.6rem'};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    max-width: 100%;
    padding: 0 2.45rem;
  }
`;

export const TextWrapper = styled(Column)`
  align-items: center;
`;

export const TitleText = styled.h2<{ color: string }>`
  color: ${({ color, theme }) => color || theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size70};
  line-height: 110%;
  text-align: center;
  max-width: 102.4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    font-size: 6rem;
    line-height: ${({ theme }) => theme.lineHeight.height125};
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: 5.5rem;
    line-height: ${({ theme }) => theme.lineHeight.height115};
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 5.2rem;
  }
`;

export const SubTitleText = styled.h2<{ color: string }>`
  color: ${({ color, theme }) => color || theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size50};
  line-height: 110%;
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size40};
    line-height: 115%;
  }
`;
